(function () {
  const root  = document.querySelector('[data-capi]');
  if (!root) return;

  const stage    = root.querySelector('[data-stage]');
  const garments = Array.from(root.querySelectorAll('.capi__garment'));
  const panel    = root.querySelector('[data-panel]');
  const scrim    = root.querySelector('[data-scrim]');
  const closeBtn = root.querySelector('[data-close]');
  const frame    = root.querySelector('[data-frame]');

  const pEyebrow = root.querySelector('[data-p-eyebrow]');
  const pTitle   = root.querySelector('[data-p-title]');
  const pBody    = root.querySelector('[data-p-body]');
  const pCta     = root.querySelector('[data-p-cta]');

  // ---------- OVERLAY FULL-PAGE (Learn more) ----------
  const overlay = root.querySelector('.capi__overlay[data-overlay]');
  const ovLeft  = root.querySelector('.capi__overlay [data-ov-left]');
  const ovRight = root.querySelector('.capi__overlay [data-ov-right]');
  const ovImg   = root.querySelector('.capi__overlay [data-ov-img]');
  const ovFig   = root.querySelector('.capi__overlay [data-ov-content-l]');
  const ovTxt   = root.querySelector('.capi__overlay [data-ov-content-r]');
  const ovTitle = root.querySelector('.capi__overlay [data-ov-title]');
  const ovLead  = root.querySelector('.capi__overlay [data-ov-lead]');
  const ovBody  = root.querySelector('.capi__overlay [data-ov-body]');
  const ovClose = root.querySelector('.capi__overlay [data-ov-close]');
  const ovVideoWrap = root.querySelector('.capi__overlay [data-ov-video]');
  const ovVframe = root.querySelector('.capi__overlay [data-ov-vframe]');
  const ovGallery = root.querySelector('.capi__overlay [data-ov-gallery]');
  const ovMedia = root.querySelector('.capi__overlay [data-ov-media]');
  const ovNav   = root.querySelector('.capi__overlay [data-ov-nav]');
  const ovPrev  = root.querySelector('.capi__overlay [data-ov-prev]');
  const ovNext  = root.querySelector('.capi__overlay [data-ov-next]');
  const ovCount = root.querySelector('.capi__overlay [data-ov-count]');
  const isDemo = root.hasAttribute('data-demo');
  const learnBtn = root.querySelector('[data-learn]');
  let ovTimer = null, ovP = 0, ovLastFocus = null, ovIndex = 0;

  function setOverlayProgress(p) {
    ovP = p;
    overlay.style.visibility = p > 0.001 ? 'visible' : 'hidden';
    overlay.style.pointerEvents = p > 0.5 ? 'auto' : 'none';
    ovLeft.style.transform  = 'translateX(' + (-(1 - p) * 100) + '%)';
    ovRight.style.transform = 'translateX(' + ((1 - p) * 100) + '%)';
  }
  function tweenOverlay(to) {
    if (ovTimer) { clearInterval(ovTimer); ovTimer = null; }
    if (reduceMotion) { setOverlayProgress(to); return; }
    const from = ovP, t0 = performance.now(), dur = 760;
    const ease = p => 1 - Math.pow(1 - p, 3);
    ovTimer = setInterval(() => {
      let p = (performance.now() - t0) / dur; if (p >= 1) p = 1;
      setOverlayProgress(from + (to - from) * ease(p));
      if (p >= 1) { clearInterval(ovTimer); ovTimer = null; }
    }, 16);
  }
  function fillOverlay(g) {
    ovTitle.textContent = g.dataset.ovTitle || g.dataset.name || '';
    ovLead.textContent  = g.dataset.ovLead || g.dataset.body || '';
    ovBody.textContent  = g.dataset.ovBody || '';
    ovBody.style.display = ovBody.textContent ? '' : 'none';
    const ph = g.querySelector('.capi__ph');
    const tone = ph ? ph.style.getPropertyValue('--tone') : '';
    overlay.style.setProperty('--ov-tone', tone || '#b8ad99');
    const img = g.dataset.ovImage;
    if (img) { ovImg.src = img; ovImg.style.display = 'block'; ovFig.style.display = 'none'; }
    else { ovImg.removeAttribute('src'); ovImg.style.display = 'none'; ovFig.style.display = 'flex'; }
    // video grande nel pannello destro
    ovVframe.querySelectorAll('video, img').forEach(n => n.remove());
    if (g.dataset.video) {
      const vv = document.createElement('video');
      vv.src = g.dataset.video; vv.autoplay = true; vv.muted = true; vv.loop = true;
      vv.playsInline = true; vv.setAttribute('playsinline','');
      ovVframe.appendChild(vv); ovVframe.classList.remove('is-empty'); ovVideoWrap.hidden = false;
    } else if (isDemo) {
      ovVframe.classList.add('is-empty'); ovVideoWrap.hidden = false;
    } else { ovVideoWrap.hidden = true; }
    // immagini aggiuntive sotto al video
    ovGallery.innerHTML = '';
    const gimgs = g.dataset.ovGallery ? g.dataset.ovGallery.split('|').filter(Boolean) : [];
    if (gimgs.length) {
      gimgs.forEach(u => { const gi = document.createElement('img'); gi.src = u; gi.className = 'capi__ov-gthumb'; gi.alt = ''; ovGallery.appendChild(gi); });
      ovGallery.hidden = false;
    } else if (isDemo) {
      for (let i = 0; i < 2; i++) { const d = document.createElement('div'); d.className = 'capi__ov-gthumb is-ph'; d.innerHTML = '<span>immagine</span>'; ovGallery.appendChild(d); }
      ovGallery.hidden = false;
    } else { ovGallery.hidden = true; }
    if (ovCount) ovCount.textContent = ('0' + (ovIndex + 1)).slice(-2) + ' / ' + ('0' + garments.length).slice(-2);
  }
  function openOverlay(g) {
    ovIndex = garments.indexOf(g);
    fillOverlay(g);
    if (ovRight) ovRight.scrollTop = 0;
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    tweenOverlay(1);
    ovLastFocus = g;
    setTimeout(() => { try { ovClose.focus(); } catch (e) {} }, 160);
  }
  function navOverlay(dir) {
    const n = garments.length;
    ovIndex = (ovIndex + dir + n) % n;
    const g = garments[ovIndex];
    rotateTo(g, false);   // mantiene il carosello sotto sincronizzato
    const parts = [ovTxt, ovImg, ovFig];
    parts.forEach(el => { if (el) { el.style.transition = 'opacity 200ms ease'; el.style.opacity = '0'; } });
    setTimeout(() => {
      fillOverlay(g);
      if (ovRight) ovRight.scrollTop = 0;
      parts.forEach(el => { if (el) el.style.opacity = '1'; });
    }, 200);
  }
  function closeOverlay() {
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    tweenOverlay(0);
    if (ovLastFocus) { try { ovLastFocus.focus(); } catch (e) {} }
  }
  if (ovClose) ovClose.addEventListener('click', closeOverlay);
  if (ovPrev) ovPrev.addEventListener('click', () => navOverlay(-1));
  if (ovNext) ovNext.addEventListener('click', () => navOverlay(1));
  if (learnBtn) learnBtn.addEventListener('click', () => {
    const f = garments.find(g => g.classList.contains('is-front'));
    if (f) openOverlay(f);
  });
  document.addEventListener('keydown', e => {
    if (overlay.getAttribute('aria-hidden') !== 'false') return;
    if (e.key === 'Escape') closeOverlay();
    else if (e.key === 'ArrowLeft') navOverlay(-1);
    else if (e.key === 'ArrowRight') navOverlay(1);
  });

  // geometria ellisse (in % del palco) — deve combaciare con <ellipse>
  const CX = 50, CY = 48, RX = 36, RY = 22;
  const S_MIN = 0.46, S_MAX = 1.0;     // scala profondità (retro → fronte)
  const O_MIN = 0.72;                  // opacità minima (retro)
  const FRONT = 90;                    // angolo frontale (basso)

  const state = { rot: 0 };
  const DEG = Math.PI / 180;

  function apply() {
    let frontEl = null, frontDelta = 999;
    garments.forEach(g => {
      const a = (parseFloat(g.dataset.angle) + state.rot) * DEG;
      const cos = Math.cos(a), sin = Math.sin(a);
      const depth = (sin + 1) / 2;                       // 0 retro → 1 fronte
      const s = S_MIN + depth * (S_MAX - S_MIN);
      const x = CX + RX * cos;
      const y = CY + RY * sin;

      g.style.left = x + '%';
      g.style.top  = y + '%';
      g.style.setProperty('--s', s.toFixed(4));
      g.style.zIndex = String(Math.round(depth * 1000));
      g.style.opacity = (O_MIN + depth * (1 - O_MIN)).toFixed(3);

      // quale capo è più vicino al fronte?
      let d = Math.abs(((parseFloat(g.dataset.angle) + state.rot - FRONT) % 360 + 540) % 360 - 180);
      if (d < frontDelta) { frontDelta = d; frontEl = g; }
    });

    garments.forEach(g => g.classList.toggle('is-front', g === frontEl));
    return frontEl;
  }

  // porta un capo al fronte scegliendo il percorso più breve
  let rotTimer = null;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function rotateTo(g, animate = true) {
    const base = parseFloat(g.dataset.angle);
    let target = FRONT - base;                 // rot tale che base+rot = FRONT
    // rappresentazione più vicina alla rotazione corrente
    while (target - state.rot >  180) target -= 360;
    while (target - state.rot < -180) target += 360;

    if (rotTimer) { clearInterval(rotTimer); rotTimer = null; }

    if (!animate || reduceMotion) { state.rot = target; apply(); return; }

    const start = state.rot;
    const dur = 1150;
    const t0 = performance.now();
    const easeInOut = p => (p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2);

    rotTimer = setInterval(() => {
      let p = (performance.now() - t0) / dur;
      if (p >= 1) p = 1;
      state.rot = start + (target - start) * easeInOut(p);
      apply();
      if (p >= 1) { clearInterval(rotTimer); rotTimer = null; }
    }, 16);
  }

  // ---------- DRAG ORIZZONTALE ----------
  // Il movimento aggiorna direttamente la rotazione dell'ellisse; al rilascio
  // il capo piu vicino viene accompagnato nella posizione frontale.
  let dragPointer = null;
  let dragStartX = 0;
  let dragLastX = 0;
  let dragLastTime = 0;
  let dragVelocity = 0;
  let inertiaFrame = null;
  let didDrag = false;
  let suppressClick = false;
  const DRAG_THRESHOLD = 5;
  const DRAG_DEGREES_PER_PX = 0.32;

  stage.addEventListener('pointerdown', e => {
    if (e.button !== 0 || e.target.closest('[data-learn]')) return;
    dragPointer = e.pointerId;
    dragStartX = dragLastX = e.clientX;
    dragLastTime = performance.now();
    dragVelocity = 0;
    didDrag = false;
    if (rotTimer) { clearInterval(rotTimer); rotTimer = null; }
    if (inertiaFrame) { cancelAnimationFrame(inertiaFrame); inertiaFrame = null; }
  });

  stage.addEventListener('pointermove', e => {
    if (e.pointerId !== dragPointer) return;
    const totalDx = e.clientX - dragStartX;
    if (!didDrag && Math.abs(totalDx) < DRAG_THRESHOLD) return;

    if (!didDrag) {
      didDrag = true;
      stage.classList.add('is-dragging');
      stage.setPointerCapture(e.pointerId);
    }
    const now = performance.now();
    const rotationDelta = -(e.clientX - dragLastX) * DRAG_DEGREES_PER_PX;
    const elapsed = Math.max(1, now - dragLastTime);
    state.rot += rotationDelta;
    // Media pesata: stabile nei movimenti lenti, reattiva nei flick veloci.
    dragVelocity = dragVelocity * 0.65 + (rotationDelta / elapsed) * 0.35;
    dragLastX = e.clientX;
    dragLastTime = now;
    apply();
    e.preventDefault();
  });

  function endDrag(e) {
    if (e.pointerId !== dragPointer) return;
    if (stage.hasPointerCapture(e.pointerId)) stage.releasePointerCapture(e.pointerId);
    dragPointer = null;
    stage.classList.remove('is-dragging');

    if (didDrag) {
      suppressClick = true;
      startInertia(dragVelocity);
      // Il click sintetico arriva dopo pointerup: lo riabilitiamo al tick seguente.
      setTimeout(() => { suppressClick = false; }, 0);
    }
  }

  function snapToNearest() {
    const nearest = apply();
    if (nearest) rotateTo(nearest);
  }

  function startInertia(velocity) {
    if (reduceMotion || Math.abs(velocity) < 0.025) {
      snapToNearest();
      return;
    }

    // Limita i flick estremi e applica un attrito indipendente dal frame rate.
    velocity = Math.max(-0.75, Math.min(0.75, velocity));
    let previousTime = performance.now();

    function coast(now) {
      const elapsed = Math.min(32, now - previousTime);
      previousTime = now;
      state.rot += velocity * elapsed;
      velocity *= Math.pow(0.92, elapsed / 16.67);
      apply();

      if (Math.abs(velocity) > 0.008) {
        inertiaFrame = requestAnimationFrame(coast);
      } else {
        inertiaFrame = null;
        snapToNearest();
      }
    }

    inertiaFrame = requestAnimationFrame(coast);
  }

  stage.addEventListener('pointerup', endDrag);
  stage.addEventListener('pointercancel', endDrag);

  // ---------- DRAWER ----------
  let lastFocus = null;
  let panelTimer = null, panelP = 0;   // 0 = chiuso, 1 = aperto

  function setPanelProgress(p) {
    panelP = p;
    panel.style.transform = 'translateX(' + ((1 - p) * 100) + '%)';
    scrim.style.opacity = String(p);
    scrim.style.visibility = p > 0.001 ? 'visible' : 'hidden';
    if (window.innerWidth > 920) {
      const pw = parseFloat(getComputedStyle(root).getPropertyValue('--panel-w')) || 460;
      stage.style.transform = 'translateX(' + (-pw / 2 * p) + 'px)';
    } else {
      stage.style.transform = 'translateX(0)';
    }
  }

  function tweenPanel(to) {
    if (panelTimer) { clearInterval(panelTimer); panelTimer = null; }
    if (reduceMotion) { setPanelProgress(to); return; }
    const from = panelP, t0 = performance.now(), dur = 640;
    const ease = p => 1 - Math.pow(1 - p, 3);
    panelTimer = setInterval(() => {
      let p = (performance.now() - t0) / dur;
      if (p >= 1) p = 1;
      setPanelProgress(from + (to - from) * ease(p));
      if (p >= 1) { clearInterval(panelTimer); panelTimer = null; }
    }, 16);
  }

  function fillPanel(g) {
    pEyebrow.textContent = g.dataset.eyebrow || 'Capo iconico';
    pTitle.textContent   = g.dataset.name || '';
    pBody.textContent    = g.dataset.body || '';
    const href = g.dataset.href || '#';
    pCta.setAttribute('href', href);

    // media: video se presente, altrimenti placeholder 9:16
    frame.querySelectorAll('video, img').forEach(n => n.remove());
    const vsrc = g.dataset.video;
    const isrc = g.dataset.image;
    if (vsrc) {
      const v = document.createElement('video');
      v.src = vsrc; v.autoplay = true; v.muted = true; v.loop = true;
      v.playsInline = true; v.setAttribute('playsinline','');
      frame.appendChild(v);
      frame.classList.remove('is-empty');
    } else if (isrc) {
      const im = document.createElement('img');
      im.src = isrc; im.alt = g.dataset.name || '';
      frame.appendChild(im);
      frame.classList.remove('is-empty');
    } else {
      frame.classList.add('is-empty');
    }
  }

  function openPanel(g) {
    fillPanel(g);
    root.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    scrim.setAttribute('aria-hidden', 'false');
    tweenPanel(1);
    lastFocus = g;
    setTimeout(() => { try { closeBtn.focus(); } catch (e) {} }, 140);
  }

  function closePanel() {
    root.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    scrim.setAttribute('aria-hidden', 'true');
    tweenPanel(0);
    const v = frame.querySelector('video');
    if (v) { try { v.pause(); } catch (e) {} }
    if (lastFocus) { try { lastFocus.focus(); } catch (e) {} }
  }

  // ---------- eventi ----------
  // Click su un capo non frontale: lo porta solo in primo piano.
  // Il pannello si apre cliccando il capo già in primo piano ("Scopri il capo").
  garments.forEach(g => {
    g.addEventListener('click', () => {
      if (suppressClick) return;
      if (g.classList.contains('is-front')) {
        openOverlay(g);
      } else {
        rotateTo(g);
      }
    });
  });

  closeBtn.addEventListener('click', closePanel);
  scrim.addEventListener('click', closePanel);
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && root.classList.contains('is-open')) closePanel();
  });

  // init: Kate al fronte
  rotateTo(garments.find(g => g.dataset.name === 'Kate') || garments[0], false);
})();
